import { Portal, Snackbar } from "@mui/material";
import { FC, Ref, useImperativeHandle, useState } from "react";
import { useLocation } from "react-router-dom";

export type SharedToLinkedInToastHandle = {
  shareSuccess: (postId: string) => void;
};

interface SharedToLinkedInToastProps {
  ref: Ref<SharedToLinkedInToastHandle>;
}

export const SharedToLinkedInToast: FC<SharedToLinkedInToastProps> = ({
  ref,
}) => {
  const location = useLocation();
  const initialPostId: string | undefined = location.state?.postId;
  const [shareToastOpen, setShareToastOpen] = useState(!!initialPostId);
  const [postId, setPostId] = useState<string | undefined>(initialPostId);

  function handleShareToastClose() {
    setShareToastOpen(false);
  }
  function showSharedToast(newPostId: string) {
    setPostId(newPostId);
    setShareToastOpen(true);
  }

  useImperativeHandle(ref, () => ({
    shareSuccess: showSharedToast,
  }));

  return (
    <Portal>
      <Snackbar
        open={shareToastOpen && !!postId}
        autoHideDuration={10000}
        onClose={handleShareToastClose}
        message="Your post has been shared on LinkedIn"
        action={
          <a
            href={"https://www.linkedin.com/feed/update/" + postId}
            target="_blank"
          >
            View post
          </a>
        }
      ></Snackbar>
    </Portal>
  );
};
